"use client";

import Image from "next/image";
import { PauseIcon, PlayIcon } from "@phosphor-icons/react/ssr";
import Container from "~/componentsDS/Layout/Container";
import Heading from "~/componentsDS/Typography/Heading";
import Overline from "~/componentsDS/Typography/Overline";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import { cn } from "~/lib/utils";
import Badge from "~/componentsDS/Badge";
import Reveal from "~/componentsDS/Reveal";
import useVslTracking from "~/hooks/useVslTracking";
import VideoPlayer from "~/componentsDS/VideoPlayer";

const ExpertFormulatedSection = () => {
    const { videoRef, videoStarted, onTogglePlay, onVideoPlay, onVideoPause, onVideoEnded } = useVslTracking();

    return (
        <section className="relative py-16 md:py-[70px] bg-primary100 md:bg-gray100 rounded-2xl md:rounded-3xl overflow-hidden">
            <Container className="relative">
                <div className="flex flex-col md:flex-row items-center text-primary500">
                    <div className="hidden md:block relative mt-auto translate-y-10">
                        <Reveal className="absolute bottom-[-30px] -left-10 w-[578px] h-[555px]">
                            <Image
                                src="https://res.cloudinary.com/dirscuuhp/image/upload/v1769457920/new_design/Model_with_AAF_Cap_2_1_gsmhgh.webp"
                                alt="Dr. Sarah Daccarett"
                                width={578}
                                height={555}
                                className="w-[578px] h-[555px] object-cover object-bottom"
                            />
                        </Reveal>
                        <div className="flex flex-col items-center gap-3 min-w-[462px] p-4 text-center rounded-lg border border-pureWhite/10 bg-trueBlack/25 backdrop-blur-[10px]">
                            <div className="font-featureDisplay text-[20px] leading-[1.2] tracking-[0.01em] text-pureWhite">Dr. Sarah Daccarett, MD</div>
                            <Badge variant="secondary" className="font-medium">Founder & CEO, Inner Balance</Badge>
                        </div>
                    </div>

                    <div className="max-w-[466px] mb-6 md:mb-0 md:ml-12">
                        <Badge variant="secondary" className="md:hidden font-medium mb-4">Meet Dr. Sarah</Badge>
                        <Heading as="h2" size="sm" sizes={{md: "md"}} className="tracking-[-0.01em] mb-4 md:mb-6">
                            Backed by science. <br className="max-md:hidden" />
                            Formulated by women’s health experts.
                        </Heading>

                        <Paragraph size="lg">
                            Inner Balance was founded by Dr. Sarah Daccarett, MD, a board-certified specialist in women’s hormonal health and longevity medicine.
                            <br/><br/>
                            Her research has been published in leading medical journals, and she is licensed to practice medicine in 50 states.
                        </Paragraph>
                    </div>

                    <div className="flex flex-col gap-3 p-4 md:ml-[60px] bg-pureWhite rounded-xl shadow-[0_2px_4px_-2px_rgba(0,0,0,0.05),_0_4px_6px_-1px_rgba(0,0,0,0.05)]">
                        <div className="group vsl-player-sm-2 rounded-xl overflow-hidden relative w-full cursor-pointer md:w-[310px]">
                            <VideoPlayer
                                ref={videoRef}
                                mp4="https://res.cloudinary.com/dirscuuhp/video/upload/v1769694160/new_design/Oestra-HRT-Education-Vaginal_Dryness-VSL-9X16-AV2-HV1-BV1-CV1-LP1-2025_11_5_nl2onu.mp4"
                                hls="https://res.cloudinary.com/dirscuuhp/video/upload/v1769694160/new_design/Oestra-HRT-Education-Vaginal_Dryness-VSL-9X16-AV2-HV1-BV1-CV1-LP1-2025_11_5_nl2onu.m3u8"
                                width="310"
                                height="414"
                                poster="https://res.cloudinary.com/dirscuuhp/image/upload/v1768993493/new_design/2d4ed36e63556a1de3ed8b78a8492fba7c31ce25_cq0mxi.webp"
                                title="Dr. Sarah Daccarett"
                                controlsList="nofullscreen"
                                playsInline
                                onPlay={onVideoPlay}
                                onPause={onVideoPause}
                                onEnded={onVideoEnded}
                                onClick={onTogglePlay}
                                className={cn(
                                    "nofullscreen w-full aspect-[310/414] object-cover object-top bg-trueBlack",
                                    "transition duration-300 ease-in-out",
                                    !videoStarted && "group-hover:scale-105"
                                )}
                            />

                            <button className={cn(
                                "w-14 h-14",
                                "flex items-center justify-center",
                                "border-2 border-pureWhite/25 group-hover:border-primary200 bg-pureWhite/5 group-hover:bg-primary200 backdrop-blur-md rounded-full",
                                "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                                "transition duration-300 ease-in-out",
                                videoStarted ? "opacity-0 group-hover:animate-[fade-out_2s_forwards]" : "",
                            )} onClick={onTogglePlay}>
                                {videoStarted ? <PauseIcon weight="fill" size={28} fill="white" /> : <PlayIcon weight="fill" size={28} fill="white" /> }
                            </button>
                        </div>
                        <Overline size="lg" className="tracking-[1.28px] max-md:text-trueBlack text-center">Hear from Dr Sarah</Overline>
                    </div>
                </div>
            </Container>
        </section>
    )
};

export default ExpertFormulatedSection;
